export default class ticketButtonCountdown {
	constructor(root) {
		this.countdownBtn = root;
   	this.init();
	}

	init() {

		//console.log('init', this.countdownBtn);

		// for each ticket button with class 'btn-countdown' setCountDown:
		var countdownBtn = this.countdownBtn;
		var presaleBtn, ticketBtn;

		countdownBtn.parentNode.childNodes.forEach( (el) => {
			if ( el.classList ) {
				if ( el.classList.contains('js-btn-presale') ) {
					presaleBtn = el;
				}
				if ( el.classList.contains('js-btn-ticket') ) {
					ticketBtn = el;
				}
			}
		})

		var x = false;

		setCountDown( countdownBtn, presaleBtn, ticketBtn );
		checkLoginStatus();

		function setCountDown( countdownBtn, presaleBtn, ticketBtn ) {

			// Set the date we're counting down to
			var countDownDate = new Date(countdownBtn.dataset.presaletimestamp).getTime();

			// Get the client's timezone offset
			var tz_offset_js = new Date().getTimezoneOffset();

			// Get the server's timezone offset
			var tz_offset_server = countdownBtn.dataset.timezoneoffsetserver;

			// Update the count down every 1 second
			x = setInterval(function () {

				// If the client changes their local timezone, prevent the ticket button will possibly be shown
				if (tz_offset_js !== new Date().getTimezoneOffset()) {
					return;
				}

				// Get today's date and time
				var now = new Date().getTime();
				var offset = customData?.timeOffset ?? 0;
				if ( offset < 0 ) {
					now = now + ( ( Math.abs( offset ) ) * 1000 );
				} else if ( offset > 0 ) {
					now = now - ( ( parseInt( offset ) ) * 1000 );
				}

				// Calculate time difference between server and client
				var tz_difference = tz_offset_server - tz_offset_js;

				// Calculate time conforming server's timezone
				now -= tz_difference * 60 * 1000;

				// Find the distance between now and the count down date
				var distance = countDownDate - now;

				// Show countdown btn if less than 2 hours till presale && not in the past:
				if ( distance < 7200000 ) {

					// Time calculations for days, hours, minutes and seconds
					var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
					var zero_m = ( minutes < 10 ) ? 0 : '';
					var seconds = Math.floor((distance % (1000 * 60)) / 1000);
					var zero_s = ( seconds < 10 ) ? 0 : '';

					// Output the result
					if ( distance >= 0 ) {
						countdownBtn.querySelector( 'span.js-countdown' ).innerHTML =  "0" + hours + ":" + zero_m + minutes + ":" + zero_s + seconds;
					}

					// Hide presale btn:
					presaleBtn.classList.add( 'is-hidden' );

					// Show presale btn:
					countdownBtn.classList.remove( 'is-hidden' );

					// Pulsen bij 30 seconden:
					if ( distance < 30000 ) {
						countdownBtn.classList.add( 'do-pulse' );
					}

					if ( distance < 0 ) {
						presaleBtn.classList.add( 'is-hidden' );
						countdownBtn.classList.add( 'is-hidden' );
						countdownBtn.classList.remove( 'do-pulse' );
						ticketBtn.classList.remove( 'is-hidden' );

						clearInterval(x);
						checkLoginStatus();
					}

				}

			}, 1000);

		}

		function checkLoginStatus() {

			if (!window.XMLHttpRequest) {
				return;
			}

			// match login cookie
			let match = document.cookie.match(new RegExp('(^| )' + ( customData?.cookieContactId ?? null ) + '=([^;]+)'));
			match = null === match ? '' : match[2];

			if ( match == '' ) {
				// return;
			}

			try {
				var xhr = new XMLHttpRequest();
				xhr.previous_text = '';
				xhr.responseType = "json";

				xhr.onerror = function() {
					console.log('XHR error');
				}
				xhr.onreadystatechange = function() {
					try {
						if (this.readyState == 4 && this.status == 200) {
							if ( this.response.result !== false ) {
								var newTimestamp = this.response.result.presale_timestamp ?? false;
								var newLabel = this.response.result.status_label ?? false;
								var newLink = this.response.result.ticket_link ?? false;
								var onSale = this.response.result.onsale ?? false;
								var isFriend = this.response.result.typeid ?? 0;

								if ( isFriend > 0 || ! customData?.friendSaleTicketInfo ) {
									document.querySelectorAll('.js-ticket-info').forEach((el) => {
										el.style.display = 'none'; // is friend so banner not required
									})
								}

								if ( ! onSale && newLabel ) {
									presaleBtn.querySelector('span').innerHTML = newLabel;
								}

								if ( newLink ) {
									clearInterval(x);
									ticketBtn.href = newLink;
									presaleBtn.classList.add( 'is-hidden' );
									countdownBtn.classList.add( 'is-hidden' );
									countdownBtn.classList.remove( 'do-pulse' );
									ticketBtn.classList.remove( 'is-hidden' );

									// hide when ticket available
									document.querySelectorAll('.js-ticket-info').forEach((el) => {
										el.style.display = 'none'; // is friend so banner not required
									})

									if ( newLabel ) {
										ticketBtn.innerHTML = newLabel;
									}
								} else {
									if ( newTimestamp ) {
										clearInterval(x);
										countdownBtn.dataset.presaletimestamp = newTimestamp;
										setCountDown(countdownBtn, presaleBtn, ticketBtn );
									}
								}
							}
						}

					} catch (e) {
						console.log(e);
					}
				}

				let eventId = ticketBtn.dataset.eventid ?? 0;
				let bundleId = ticketBtn.dataset.bundleid ?? 0;
				let postId = ticketBtn.dataset.post_id ?? 0;
				let params = '&post_id=' + postId + ( bundleId > 0 ? '&bundle_id=' + bundleId : '&event_id=' + eventId );

				if ( 'undefined' != typeof document.documentElement.lang ) {
					let lang = document.documentElement.lang;
					if ( lang.length > 2 ) {
						lang = lang.substring(0,2).toLowerCase();
					}
					params += '&lang=' + lang;
				}

				xhr.open('POST', customData.ajaxUrl, true);
				xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
				xhr.send('action=check_login' + params);
			} catch (e) {
				console.log('XHR failed request');
			}
		}

	}

}
